import { Grid, useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';
import { get as _get } from 'lodash';
import { useState } from 'react';
import { EMAIL_REGEX } from '../../../utils/Regex-Util';
import { RegexTextField } from '../../shared/RegexTextField/RegexTextField';

export default function EmailInput(props: any) {
  const [emailAddress, setEmailAddress] = useState(_get(props, 'defaultValue', ''));
  const [isEmailValid, setIsEmailValid] = useState(
    !!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(_get(props, 'defaultValue', '')) || !props.isRequired
  );
  const theme = useTheme();
  props.emailValid(isEmailValid);

  function emailChange(e: any) {
    const email = _get(e, 'target.value', '');
    setEmailAddress(email);
    props.emailValueUpdate(email);

    if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)) {
      setIsEmailValid(true);
      props.emailValid(true);
    } else if (!props.isRequired && !email) {
      setIsEmailValid(true);
      props.emailValid(true);
    }
  }

  function validateChange(e: any) {
    const email = _get(e, 'target.value', '');
    const valid = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email);
    if (!props.isRequired && !email) {
      setIsEmailValid(true);
      props.emailValid(true);
    } else {
      setIsEmailValid(valid);
      props.emailValid(valid);
    }
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography sx={{ ...theme.custom.styles.formLabelStyle, marginBottom: '5px' }}>Email Address</Typography>
      </Grid>
      <Grid item xs={12}>
        <RegexTextField
          sx={{
            width: props.width || '100%',
            marginTop: '0px',
          }}
          variant="outlined"
          margin="dense"
          type="email"
          size="small"
          regex={EMAIL_REGEX}
          changeHandler={emailChange}
          onBlur={validateChange}
          value={emailAddress}
        />
      </Grid>
      {!isEmailValid && (
        <Grid
          sx={{
            marginTop: '0px',
            marginRight: props.margin || '0%',
            display: 'flex',
          }}
          item
          xs={12}
        >
          <Typography sx={theme.custom.styles.errorSubcaseFont}>
            {props.isRequired ? 'Required' : 'Enter a Valid Email Address'}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
}
